import { type FC } from 'react';
import { Badge, Blockquote, Card, Stack, Text } from '@mantine/core';
import { IconMessage } from '@tabler/icons-react';
import {
    formatTicket,
    payoutTicketPriorityColors,
    payoutTicketStatusColors,
    type PayoutTicket,
} from '~/entities/payout';
import { KeyValuePair } from '~/shared/ui/KeyValuePair';
import s from './style.module.css';

interface TicketDetailsProps {
    ticket: PayoutTicket;
}

export const TicketDetails: FC<TicketDetailsProps> = ({ ticket }) => {
    return (
        <Card p={10}>
            <Card.Section
                withBorder
                inheritPadding
                py={10}
            >
                <KeyValuePair
                    label='ID'
                    value={<Text>{ticket.id?.value || '-'}</Text>}
                    direction='row'
                />
            </Card.Section>

            <Stack>
                <Blockquote
                    radius={0}
                    my='xl'
                    color='blue'
                    px='xs'
                    icon={<IconMessage />}
                    className={s.message}
                >
                    {ticket.message}
                </Blockquote>

                {ticket.status && (
                    <KeyValuePair
                        label='Статус'
                        direction='row'
                        value={
                            <Badge
                                color={payoutTicketStatusColors[ticket.status]}
                                fz='xs'
                            >
                                {formatTicket.status(ticket.status)}
                            </Badge>
                        }
                    />
                )}

                {ticket.priority && (
                    <KeyValuePair
                        label='Приоритет'
                        direction='row'
                        value={
                            <Badge
                                color={payoutTicketPriorityColors[ticket.priority]}
                                fz='xs'
                            >
                                {formatTicket.priority(ticket.priority)}
                            </Badge>
                        }
                    />
                )}

                {ticket.createdAt && (
                    <KeyValuePair
                        direction='row'
                        label='Дата создания'
                        value={formatTicket.date(ticket.createdAt)}
                    />
                )}
            </Stack>
        </Card>
    );
};
